<template>
  <div v-if="totalPages > 1" class="gallery-pagination">
    <button v-if="currentPage > 1" class="pg-btn pg-first" aria-label="First page" title="First page"
      @click="$emit('page-change', 1)">
      <FirstIcon class="pg-icon" />
    </button>
    <button v-if="currentPage > 1" class="pg-btn pg-prev" aria-label="Previous page" title="Previous page"
      @click="$emit('page-change', currentPage - 1)">
      <PreviousIcon class="pg-icon" />
    </button>

    <span class="pg-label">Page</span>
    <select class="pg-select" :value="currentPage" aria-label="Select page"
      @change="$emit('page-change', Number($event.target.value))">
      <option v-for="page in totalPages" :key="page" :value="page">{{ page }}</option>
    </select>

    <button v-if="currentPage < totalPages" class="pg-btn pg-next" aria-label="Next page" title="Next page"
      @click="$emit('page-change', currentPage + 1)">
      <NextIcon class="pg-icon" />
    </button>
    <button v-if="currentPage < totalPages" class="pg-btn pg-last" aria-label="Last page" title="Last page"
      @click="$emit('page-change', totalPages)">
      <LastIcon class="pg-icon" />
    </button>
  </div>
</template>

<script>
import FirstIcon from '@/assets/icons/first.vue'
import PreviousIcon from '@/assets/icons/previous.vue'
import NextIcon from '@/assets/icons/next.vue'
import LastIcon from '@/assets/icons/last.vue'

export default {
  name: 'GalleryPagination',
  components: { FirstIcon, PreviousIcon, NextIcon, LastIcon },
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  emits: ['page-change']
}
</script>

<style scoped>
.gallery-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 16px 0;
}

.pg-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--color-text);
  cursor: pointer;
  transition: background 0.15s;
  padding: 0;
  touch-action: manipulation;
}

@media (hover: hover) {
  .pg-btn:hover:not(:disabled) {
    background: color-mix(in srgb, var(--color-text) 10%, var(--color-bg));
  }
}

.pg-icon {
  pointer-events: none;
}

.pg-label {
  font-size: var(--font-sm);
  color: var(--color-text);
  margin-right: -2px;
}

.pg-select {
  height: 36px;
  padding: 0 12px 0 10px;
  margin: 0 2px;
  border: 1px solid color-mix(in srgb, var(--color-text) 30%, transparent);
  border-radius: var(--radius);
  background: var(--color-bg);
  font-size: var(--font-sm);
  font-family: inherit;
  color: var(--color-text);
  cursor: pointer;
  appearance: auto;
}

.pg-select:focus {
  outline: none;
  border-color: var(--color-text);
}
</style>
